import {Component, OnInit, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {DataService, DatasetBannerModel} from 'src/app/services/data.service';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {tap, catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-vendor-banner',
  templateUrl: './vendor-banner.component.html',
  styleUrls: ['./vendor-banner.component.scss']
})
export class VendorBannerComponent implements OnInit {

  backgroundImage = '';
  isDatasetView = false;
  isModalView = false;
  isPredictionView = false;
  isTeamView = false;
  isForumView = false;
  isLeaderboardView = false;
  isRulesView = false;
  isPrizeView = false;
  isAskAIView = false;
  downloading = false;
  loadingToken = false;
  imagePrefix = 'data:image/png;base64,';
  dataset: any;
  datasetFiles: any[] = [];

  constructor(public domSanitizer: DomSanitizer, public dataservice: DataService, private router: Router,
              public datasetBannerModel: DatasetBannerModel, private trustiiService: TrustiiService,
              private dialogService: DialogService) {
  }

  ngOnInit() {
    this.getDataset();
    this.getDatasetFiles();
    this.datasetBannerModel.datasetBannerUpdate.subscribe(() => {
      this.isDatasetView = this.datasetBannerModel.isDatasetView;
      this.isModalView = this.datasetBannerModel.isModalView;
      this.isPredictionView = this.datasetBannerModel.isPredictionView;
      this.isForumView = this.datasetBannerModel.isForumView;
      this.isTeamView = this.datasetBannerModel.isTeamView;
      this.isLeaderboardView = this.datasetBannerModel.isLeaderboardView;
      this.isRulesView = this.datasetBannerModel.isRulesView;
      this.isPrizeView = this.datasetBannerModel.isPrizeView;
      this.isAskAIView = this.datasetBannerModel.isAskAIView;
    });
    const img = this.datasetBannerModel.dataset.image !== null ?
      this.datasetBannerModel.dataset.image :
      this.dataservice.defaultDatasetIcon;
    this.backgroundImage = this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL,
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.imagePrefix + img));
  }

  getDataset() {
    this.trustiiService.getDataset(this.datasetBannerModel.dataset.id)
      .pipe(
        tap((dataset: any) => this.dataset = dataset.data),
        tap((dataset: any) => Object.assign(this.datasetBannerModel.dataset, dataset.data)),
        tap((dataset: any) => this.dataservice.data = dataset.data),
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe();
  }

  getDatasetFiles() {
    this.trustiiService.getDatasetFiles(this.datasetBannerModel.dataset.id)
      .pipe(
        tap((files: any) => this.datasetFiles = files.data),
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe();
  }

  loadDatasetView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id);
  }

  loadModalView() {
    this.router.navigateByUrl('vendor/datasets/' + this.datasetBannerModel.dataset.id + '/mlmodels');
  }

  loadPredictionView() {
    this.router.navigateByUrl('vendor/datasets/' + this.datasetBannerModel.dataset.id + '/predictions');
  }

  loadForumView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/forums');
  }

  loadRulesView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/rules');
  }

  loadLeaderBoardView() {
    this.router.navigateByUrl('leaderboard/' + this.datasetBannerModel.dataset.id);
  }

  loadLeaderBoardV2View() {
    this.router.navigateByUrl('leaderboard-v2/' + this.datasetBannerModel.dataset.id);
  }

  loadPrizeView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/prize');
  }

  loadTeamView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/team');
  }

  loadAskAIView() {
    this.router.navigateByUrl('datasets/' + this.datasetBannerModel.dataset.id + '/ask-ai');
  }

  redirectToUploadPredictions() {
    this.dataservice.setData({vendorDownloadedDatasetId: this.datasetBannerModel.dataset.id});
    this.router.navigateByUrl(`vendor/datasets/${this.datasetBannerModel.dataset.id}/predictions/upload`);
  }

  redirectToJupyter(url) {
    window.open(url + '?token=' + localStorage.getItem('token'));
  }

  redirectToResult(url) {
    window.open(url);
  }

  loadUploadModelWiki() {
    window.open('https://colab.research.google.com/gist/Trustii-team/44d005401e2397707d21501e1a2df64b/' +
      'making_your_first_submission_on_trustii-io.ipynb');
  }

  downloadDataset(part = 'D1') {
      window.open(this.trustiiService.getDatasetDownloadLink(this.datasetBannerModel.dataset.id, part));
  }

  downloadDatasetFile(file: any) {
    window.open(this.trustiiService.getDatasetOtherFileLink(this.datasetBannerModel.dataset.id, file.id));
  }

  getDatasetToken() {
    this.loadingToken = true;
    this.trustiiService.getDatasetToken(this.datasetBannerModel.dataset.id).subscribe(
      (res) => {
        this.loadingToken = false;
        window.open(res.data.url + '?token=' + res.data.token);
      },
      (err) => {
        this.loadingToken = false;
        this.dialogService.openAlertDialog(
          '350px',
          'failed to create a session on JupyterHub, please contact our support team.',
          'ERROR',
          'Close',
          'modal-warning'
        );
      }
    );
  }

  backToDataset() {
    this.router.navigateByUrl('datasets');
  }

}

